module.exports = __webpack_public_path__ + "static/ContinuousCVReviews-f8985bc668e3b53e81cb74e8dd302365.jpg";